const TokenKey = 'Admin-Token'
const RefreshTokenKey = 'Refresh-Token'
const Openid = 'Openid'
const Img = 'Img'
const Userid = 'Userid'
const NavIndex = 'Nav-index'
// localStorage方式
export function getToken() {
  return sessionStorage.getItem(TokenKey)
}

export function setToken(token) {
  return sessionStorage.setItem(TokenKey, token)
}

export function removeToken() {
  return sessionStorage.removeItem(TokenKey)
}
// Refreshtoken (逻辑和token一样)
export function getRefreshToken() {
  return sessionStorage.getItem(RefreshTokenKey)
}

export function setRefreshToken(refreshtoken) {
  return sessionStorage.setItem(RefreshTokenKey, refreshtoken)
}

export function removeRefreshToken() {
  return sessionStorage.removeItem(RefreshTokenKey)
}

// openid (逻辑和token一样)
export function getOpenid() {
  return sessionStorage.getItem(Openid)
}

export function setOpenid(openid) {
  return sessionStorage.setItem(Openid, openid)
}

export function removeOpenid() {
  return sessionStorage.removeItem(Openid)
}
// userid
export function getUserid() {
  return sessionStorage.getItem(Userid)
}

export function setUserid(userid) {
  return sessionStorage.setItem(Userid, userid)
}

export function removeUserid() {
  return sessionStorage.removeItem(Userid)
}
// 获取用户id
export function getImg () {
  return sessionStorage.getItem(Img)
}

export function setImg (img) {
  return sessionStorage.setItem(Img, img)
}

export function removeImg () {
  return sessionStorage.removeItem(Img)
}
// navIndex
export function getNavIndex() {
  return sessionStorage.getItem(NavIndex)
}

export function setNavIndex(navIndex) {
  return sessionStorage.setItem(NavIndex, navIndex)
}

export function removeNavIndex() {
  return sessionStorage.removeItem(NavIndex)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js